// extracted by mini-css-extract-plugin
export default {"icon":"IconDashboard_icon__SpfEY","iconSelected":"IconDashboard_iconSelected__PrN+-"};